import Skeleton from 'react-loading-skeleton';
import './unassignedStudyCardSkeleton.scss';

/**
 * Renders the placeholder card shown while unassigned studies load. Lays out skeleton blocks for the header's left and right areas and for two body items.
 *
 * @returns The skeleton unassigned study card element.
 */
const UnassignedStudyCardSkeleton = () => (
  <div className="unassigned-study-card-skeleton-container">
    <div className="header-container">
      <div className="left-container">
        <Skeleton height="100%" />
      </div>
      <div className="right-container">
        <Skeleton height="100%" />
      </div>
    </div>
    <div className="body-container">
      <div className="item-container">
        <Skeleton height="100%" />
      </div>
      <div className="item-container">
        <Skeleton height="100%" />
      </div>
    </div>
  </div>
);

export default UnassignedStudyCardSkeleton;
